import React from 'react';
import '../styling/HomePage.css';
import GamePage from './GamesPage';
import AboutPage from './AboutPage';
import ContactPage from './ContactPage';
import UpdatesPage from './UpdatesPage';
import Header from './Header';
import Footer from './Footer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

function HomePage() {
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="home-container">
      <Header />

      {/* Hero Section */}
      <section id="hero" className="hero-section">
        <div className="hero-content">
          <img src='./Kyro-Studios.png' className='hero-logo row' alt="Hero Logo"/>
          <button className="cta-button btn" onClick={() => scrollToSection('games')}>
            <strong>Explore Our Newest Game</strong>
          </button>
          <div className='arrow mx-auto'>
            <FontAwesomeIcon icon={faChevronDown}  style={{ fontSize: '80px' }} onClick={() => scrollToSection('games')}/>
          </div>
        </div>
      </section>

      {/* Games Section */}
      <section id="games" className="section">
        <GamePage />
      </section>

      {/* About Section */}
      <section id="about" className="section">
        <AboutPage />
      </section>

      {/* Contact Section */}
      <section id="contact" className="section">
        <ContactPage />
      </section>

      {/* Updates Section */}
      <section id="updates" className="section">
        <UpdatesPage />
      </section>

      {/* Footer Section */}
      <section id="footer" className="section">
        <Footer />
      </section>
    </div>
  );
}

export default HomePage;
